import axios from "axios";

export const downloadFile = async ({ api, method = "get", data = null }) => {
  try {
    const url = `${process.env.REACT_APP_API_URL}${api}`;

    const config = {
      responseType: "blob",
    };

    let response;

    if (["get", "delete"].includes(method.toLowerCase())) {
      response = await axios[method](url, config);
    } else {
      response = await axios[method](url, data, config);
    }

    const blob = response.data;

    // ✅ If backend sends JSON instead of PDF
    if (blob.type.includes("application/json")) {
      const text = await blob.text();
      const json = JSON.parse(text);
      alert(json.message || "No data found");
      return;
    }

    // ✅ filename
    let fileName = `${JSON.parse(response?.config?.data)?.saralId}.pdf` || "download.pdf";
    const contentDisposition = response.headers["content-disposition"];

    if (contentDisposition) {
      const match = contentDisposition.match(/filename="?([^"]+)"?/);
      if (match?.[1]) fileName = match[1];
    }

    // ✅ Download
    const downloadUrl = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = downloadUrl;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();

    link.remove();
    window.URL.revokeObjectURL(downloadUrl);

  } catch (error) {
    console.log("Download error:", error);

    // 🔥 IMPORTANT PART
    if (error.response?.data instanceof Blob) {
      const text = await error.response.data.text();
      const json = JSON.parse(text);
      alert(json.message || "Something went wrong");
    } else {
      alert("File download failed");
    }
  }
};





    